import { render, staticRenderFns } from "./AddPromotionBundle.vue?vue&type=template&id=9fdff166"
import script from "./AddPromotionBundle.vue?vue&type=script&lang=js"
export * from "./AddPromotionBundle.vue?vue&type=script&lang=js"
import style0 from "./AddPromotionBundle.vue?vue&type=style&index=0&id=9fdff166&prod&lang=css"
import style1 from "./AddPromotionBundle.vue?vue&type=style&index=1&id=9fdff166&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports